import { useInfiniteQuery } from '@tanstack/react-query';
import { getTaskService } from '@src/container';

export interface ListTasksParams {
    status?: string;
    skip?: number;
    limit?: number;
}

export const useListTasksPaginated = (params: ListTasksParams = {}) => {
    const taskService = getTaskService();

    return useInfiniteQuery({
        queryKey: ['tasks', 'list', params],
        queryFn: async ({ pageParam = 0 }) => {
            const skip = pageParam * (params.limit || 20);
            return taskService.listTasksPaginated({
                ...params,
                skip,
                limit: params.limit || 20,
            });
        },
        getNextPageParam: (lastPage, _, lastPageParam) => {
            return lastPage.hasMore ? lastPageParam + 1 : undefined;
        },
        initialPageParam: 0,
        // Enable refetching when params change
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};